module.exports = __webpack_public_path__ + "static/media/profile-hand-bottom.5e330f72.svg";